import React from 'react';
import type { EditorStep } from './editorSteps';

const STEPS: { key: EditorStep; short: string }[] = [
  { key: 'people', short: 'People' },
  { key: 'numbers', short: 'Counts' },
  { key: 'generosity', short: 'Giving' },
  { key: 'review', short: 'Review' },
];

const stepIndex = (s: EditorStep) => STEPS.findIndex((x) => x.key === s);

interface ProgressBarProps {
  active: EditorStep;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ active }) => {
  if (active === 'welcome' || active === 'thanks') return null;

  const activeIdx = stepIndex(active);
  if (activeIdx < 0) return null;

  return (
    <div className="px-4 py-2.5 bg-white border-b border-gray-100 shrink-0">
      <div className="flex gap-1.5">
        {STEPS.map((sec, idx) => {
          const isActive = sec.key === active;
          const isDone = idx < activeIdx;
          return (
            <div key={sec.key} className="flex-1 flex flex-col gap-1">
              <div
                className={`h-1 rounded-full transition-colors duration-300 ${
                  isActive ? 'bg-primary-600' : isDone ? 'bg-primary-300' : 'bg-gray-200'
                }`}
              />
              <span
                className={`text-[10px] sm:text-xs font-medium text-center truncate ${
                  isActive ? 'text-primary-700' : isDone ? 'text-primary-500' : 'text-gray-400'
                }`}
              >
                {sec.short}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
